import { TranslatePipe } from '../../filters/translate.pipe';
import { ElementRef } from '@angular/core';
import { Component, OnInit, inject, OnDestroy } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import { Input } from '@angular/core';

@Component({
	standalone: true,
	selector: 'guide-info-popover',
	templateUrl: './guide-info-popover.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class GuideInfoPopoverComponent implements OnInit, OnDestroy {
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	
	@Input() color: any | undefined;
	@Input() businessServiceSetting: any;
	@Input() wrapper: any | undefined;
	@Input() placement: any | undefined;
	@Input() placementMobile: any | undefined;
	@Input() wrapperMobile: any | undefined;
	
	vm: any = undefined;
	watcher: any = undefined;
	
	constructor(private elementRef: ElementRef) {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.mobileBreakpoint = 768;
		this.vm.placement = this.vm.placement || 'bottom';
		this.vm.placementMobile = this.vm.placementMobile || this.vm.placement;
		this.handleParamsUpdate();
		
		this.vm.element = this.angularHelperService.element(this.elementRef.nativeElement);
		this.vm.isOpen = true;
		
		this.angularHelperService.element(this.angularHelperService.getWindow()).on('resize', () => { this.handleParamsUpdate(); });

		var currentIsOpen = this.vm.isOpen;
		this.watcher = this.angularHelperService.createInterval(() => {
			var newIsOpen = this.vm.isOpen;
			if (currentIsOpen !== newIsOpen) {
				currentIsOpen = newIsOpen;
				this.handleIsOpenChange(newIsOpen);
			}
		}, 100);
		
		this.vm.handleCloseButtonClick = this.handleCloseButtonClick;
		this.vm.redirect = this.redirect;
	}
	
	ngOnDestroy() {
		this.angularHelperService.element(this.angularHelperService.getWindow()).off('resize', () => { this.handleParamsUpdate(); });
		if (this.watcher) {
			this.angularHelperService.cancelInterval(this.watcher);
		}
	}

	handleCloseButtonClick() {		
		this.vm.isOpen = false;
		this.vm.businessServiceSetting.hasSeenGuide = true;
		this.restService.saveUpdateHasSeenGuide(this.vm.businessServiceSetting)
			.then((data) => {
				console.log(data);
			})
			.catch((err) => {
				console.error(err);
			});
	}
	
	redirect($event, link) {
		$event.preventDefault();
		window.location.href = link;
	}

	handleIsOpenChange(isOpen) {
		if (isOpen) {
			requestAnimationFrame(() => {
				var modifiers: any = { flip: { behavior: [this.vm.placement, this.vm.placementMobile] } };
				if (this.vm.popperWrapper) modifiers.preventOverflow = { boundariesElement: this.vm.popperWrapper };
				
				this.vm.popoverElement = this.vm.element[0].querySelector('.c-guide-popover');
			});
		}
	}

	handleParamsUpdate() {
		if (window.innerWidth < this.vm.mobileBreakpoint) {
			this.vm.popperPlacement = this.vm.placementMobile;
			this.vm.popperWrapper = this.vm.wrapperMobile;
		} else {
			this.vm.popperPlacement = this.vm.placement;
			this.vm.popperWrapper = this.vm.wrapper;
		}
	}
	
}